import DrawerMenu from 'app/components/common/DrawerMenu';
import { P } from 'app/components/common/Typography';
import React, { useState } from 'react';
import { Drawer, NavBar, Button } from 'mui';
import DoctorMattImage from 'images/doctors/matt.jpg';
import DoctorRandImage from 'images/doctors/rand.jpg';
import DoctorWayneImage from 'images/doctors/wayne.jpg';
import DoctorJimImage from 'images/doctors/jim.jpg';
import DoctorEugeneImage from 'images/doctors/eugene.jpg';
import SetProductDialog from '@setproduct-ui/core/Dialog/Dialog';
import '../css/Interstitial.scss';
import { apiRequestUserCommand } from 'app/actions/customer';
import { push } from 'connected-react-router/immutable';
import { useAppDispatch, useAppSelector } from 'app/helpers/hooks';
import * as selectors from 'app/selectors/customer';
import { selectFurthestProductStepPath } from 'app/selectors/customer';
import { AvailableProducts } from 'app/constants/Products';

const DOCTORS = [
  {
    image: DoctorMattImage,
    name: 'Matt Coward, MD',
    text: 'Associate Professor of Urology, UNC School of Medicine',
  },
  {
    image: DoctorRandImage,
    name: 'Rand McClain, MD',
    text: 'Founder, Regenerative & Sports Medicine',
  },
  {
    image: DoctorWayneImage,
    name: 'Wayne Hellstrom, MD',
    text: 'Professor of Urology, Chief of Andrology, Tulane School of Medicine',
  },
  {
    image: DoctorJimImage,
    name: 'Jim Hotaling, MD',
    text: 'Associate Professor of Urology, University of Utah Health',
  },
  {
    image: DoctorEugeneImage,
    name: 'Eugene Shippen, MD',
    text: 'Family Medicine & Endocrinology, Reading Hospital',
  },
];

const DoctorsList = ({ prefix = '' }) =>
  DOCTORS.map((item) => (
    <div className="slide" key={`${prefix}${item.name}`}>
      <div>
        <img src={item.image} alt="" />
      </div>
      <div>
        <h5>{item.name}</h5>
        <P>{item.text}</P>
      </div>
    </div>
  ));
const Doctors = ({ setDialogOpen }) => {
  const dispatch = useAppDispatch();
  const intake = useAppSelector(selectors.selectCurrentIntake);
  const onSuccessActionCreator = (_, stateAfterSuccess) =>
    push(selectFurthestProductStepPath({ customer: stateAfterSuccess }, AvailableProducts.King));
  const action = apiRequestUserCommand({
    cmdType: 'answer_questions',
    params: { built_with_doctors: true, intake: intake.get('name') },
    context: {
      onSuccessActionCreator,
    },
  });
  const handleClose = () => {
    setDialogOpen(false);
    dispatch(action);
  };
  return (
    <div>
      <Drawer sideContent={<DrawerMenu loggedIn={false} />}>
        <NavBar />
        <div className="doctors-slider">
          <div className="group">
            <DoctorsList />
          </div>
          <div aria-hidden className="group">
            <DoctorsList prefix="duplicate-desktop" />
          </div>
        </div>
        <div className="doctors-slider mobile">
          <div className="group">
            <DoctorsList prefix="mobile-" />
          </div>
          <div aria-hidden className="group">
            <DoctorsList prefix="duplicate-" />
          </div>
        </div>
        <div className="centered-content">
          <h5 className="interstitial_header">EXPERT ADVICE</h5>
          <P className="interstitial_content">Built with doctors who specialize in men’s hormone therapies</P>
          <Button className="close" onClick={handleClose}>
            Next
          </Button>
        </div>
      </Drawer>
    </div>
  );
};

const DoctorsPage = () => {
  const [dialogOpen, setDialogOpen] = useState(true);

  return (
    <SetProductDialog
      isOpen={dialogOpen}
      text={<Doctors setDialogOpen={setDialogOpen} />}
      showCloseModalIcon={false}
      dialogClassName="interstitial_container"
    />
  );
};

export default DoctorsPage;
